export default __webpack_public_path__ + "images/de383aa894f4313346aff5dd58c8298a.jpg";